class StickyAtc extends HTMLElement {
  constructor() {
    super();
    
    this.triggerExpand = this.querySelector(".js-open-variants");
    this.variantSelector = this.querySelector(".js-sticky-atc-variant-selector");
    this.mainProductSection = document.querySelector(".js-main-product-section");
    this.stickyAtcElement = document.querySelector(".js-sticky-atc");
    this.stickyAtcButton = document.querySelector(".js-atc-button.sticky-atc__button");

    this.triggerExpand.addEventListener("click", this.openVariantSelector);
    // to close the second "screen" on mobile
    document.addEventListener("click", (e) => {
      if (this.variantSelector.classList.contains("active") && !this.variantSelector.contains(e.target) && !this.contains(e.target) || e.target ===  this.stickyAtcButton) {
        this.variantSelector.classList.remove("active");
        this.variantSelector.setAttribute("aria-hidden", true);
      }
    })

    // update zendesk widget position
    document.addEventListener("scroll", (e) => {
      const zendesk = document.getElementById('launcher')
      const stickyAtcBot = this.stickyAtcElement.getBoundingClientRect().bottom
      // const mainBot = this.main.getBoundingClientRect().bottom

      // if (zendesk) {
      //   zendesk.style.bottom = (stickyAtcBot < mainBot && this.stickyAtcElement.classList.contains('active'))
      //     ? `${this.stickyAtcElement.offsetHeight}px`
      //     : '0px'
      // }
    })

    // only shows the sticky atc once you've scrolled past the main product section
    const observer = new IntersectionObserver(entries => {
      const element = entries[0];
      element.isIntersecting ? this.stickyAtcElement.classList.remove("active") : this.stickyAtcElement.classList.add("active");
    })

    observer.observe(this.mainProductSection);
  }

  // to open the second "screen" on mobile
  openVariantSelector = () => {
    this.variantSelector.classList.add("active");
    this.variantSelector.setAttribute("aria-hidden", false);
  }
}

customElements.define("sticky-atc", StickyAtc);
